import { combineReducers } from "redux"
import Bien from './Bien'
import Offer from './Offer'


const reducers = { Bien, Offer }
export const Reducer = combineReducers(reducers) // combineReducers({ ...reducers });